import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';
import {selectSuggestionId,} from './suggestion.action';

const defaultState = {
    selectedSuggestionId: -1,
    drawerOpen: false,
    suggestions: []
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

// Drop null entries and entries without an id so renders can trust the list.
const normalizeSuggestions = (suggestions: any): any[] => {
  return Array.isArray(suggestions)
    ? suggestions.filter((suggestion) => suggestion && typeof suggestion === "object" && suggestion.id !== undefined)
    : [];
};

reducer
  .on(selectSuggestionId, (state, payload) => {
    return {
      ...state,
      selectedSuggestionId: payload,
    };
  })
  .on(commonWebSocket.snapshot.SUGGESTIONS_SNAPSHOT, (state: any, payload: any) => {
    if (!Array.isArray(payload?.suggestions)) {
      return state;
    }
    return {
      ...state,
      suggestions: normalizeSuggestions(payload.suggestions),
    };
  })
  .on(commonWebSocket.replace.SUGGESTION_UPDATE, (state: any, payload: any) => {
    if (!payload?.suggestionUpdate || payload.suggestionUpdate.id === undefined) {
      return state;
    }

    const newSuggestions = Array.isArray(state.suggestions) ? state.suggestions.slice() : [];

    const suggestionToUpdateIndex = newSuggestions.findIndex((suggestion: any) => {
      return suggestion.id === payload.suggestionUpdate.id;
    });

    if (suggestionToUpdateIndex === -1) {
      newSuggestions.push(payload.suggestionUpdate);
    } else {
      newSuggestions[suggestionToUpdateIndex] = payload.suggestionUpdate;
    }

    return {
      ...state,
      suggestions:newSuggestions
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/suggestion/suggestion.reducer.ts